import {PUBLIC_AVATAR_PRESETS} from './avatar-entitlements.mjs';
import {ContractError,validateAvatar,validatePlayerName} from './world-contract.mjs';

// This marker records an explicit first-entry choice only. It conveys no
// verified identity, ownership, creator role, credit balance, or entitlement.
export function validateAvatarProfile(player,payload,{allowedPresets=PUBLIC_AVATAR_PRESETS}={}) {
  if(!payload||typeof payload!=='object'||Array.isArray(payload))throw new ContractError('Expected a profile update');
  if(payload.completeProfile!==undefined&&payload.completeProfile!==true)throw new ContractError('Invalid profile completion');
  if(payload.completeProfile===true&&(payload.name===undefined||!allowedPresets.includes(payload.avatar?.preset)))throw new ContractError('Choose a display name and a default avatar to continue');
  return {
    name:payload.name!==undefined?validatePlayerName(payload.name):player.name,
    avatar:payload.avatar!==undefined?{...player.avatar,...validateAvatar(payload.avatar,{allowedPresets})}:player.avatar,
    profileCompleted:player.profileCompleted===true||payload.completeProfile===true,
  };
}

export function needsProfileSetup(player,{local=false,capabilities={},account={}}={}) {
  return (local||capabilities.profileSetup===true)&&(player?.profileCompleted!==true||(account.kind==='authenticated'&&account.needsUsername===true));
}

export function profileLabel(player) {
  const name=player?.displayName??player?.name??'Wanderer';
  return player?.username?`${name} · @${player.username}`:name;
}

export function applyProfileSnapshot(player,snapshot) {
  if(!player||!snapshot)return player;
  for(const key of ['name','displayName','username','profileCompleted'])if(snapshot[key]!==undefined)player[key]=snapshot[key];
  if(snapshot.profileName!==undefined||snapshot.name!==undefined)player.profileName=snapshot.profileName??snapshot.name;
  return player;
}

